<script>
  import QuestionFrame from './QuestionFrame.svelte';
</script>

<QuestionFrame>
  <p>Verändern sich die Schmerzen bei oder nach dem Wasserlassen, Stuhlgang, Geschlechtsverkehr?</p>
  <p class="italic">
    Hinweis: Meist sind die Schmerzen danach verstärkt, manchmal jedoch auch vermindert.
  </p>
</QuestionFrame>
